/**
 * Spirit energy: the cost of magic.
 *
 * Regenerates on its own, so magic is a rhythm rather than a consumable to
 * hoard — a resource you must go home to refill turns a spell into something
 * players save for a boss they never quite meet.
 */
export class Spirit {
  private value: number;

  constructor(
    readonly max: number,
    /** Points per second. */
    private readonly regen: number = 4,
  ) {
    this.value = max;
  }

  get current(): number {
    return this.value;
  }

  update(dt: number): void {
    this.value = Math.min(this.max, this.value + this.regen * dt);
  }

  /** Give some back, capped at the maximum. For Spirit Draw. */
  gain(amount: number): void {
    this.value = Math.min(this.max, this.value + Math.max(0, amount));
  }

  has(cost: number): boolean {
    return this.value >= cost;
  }

  /** Spend, or return false and spend nothing. */
  spend(cost: number): boolean {
    if (!this.has(cost)) return false;
    this.value -= cost;
    return true;
  }

  restore(): void {
    this.value = this.max;
  }
}
